$(document).ready(function () {
	if ($('.swiper--cards-slider').length > 0) {
		new Swiper(".swiper--cards-slider", {
			slidesPerView: 1.08,
			spaceBetween: 22,
			loop: true,
			speed: 900,
			autoplay: {
				delay: 4500,
				disableOnInteraction: false,
			},
			pagination: {
				el: ".pagination-cards-slider",
				clickable: true,
			},
			breakpoints: {
				768: {
					slidesPerView: 1.35,
					spaceBetween: 24,
				},
				992: {
					slidesPerView: 2.15,
					spaceBetween: 24,
				},
				1200: {
					slidesPerView: 2.15,
					spaceBetween: 24,
				},
			},
		});
	}
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/swiper-cards.js